<div class="platform-container m-a">
  <div class="side-menu-panel">
    <cp-side-panel-navigation />
  </div>
  <div class="platform-content grid" #platformContent>
    <cp-navigation-header
      class="relative top-0 header"
      [isMobileHeaderVisible]="shouldDisplayMobileHeaderAndMenu" />
    <div
      class="h-100 overflow-auto"
      (mousemove)="setLastMousePosition($event)"
      [@routeAnimations]="getRouteAnimationData() | async">
      <router-outlet (activate)="onActivate()" />
    </div>

    @if (
      (size$ | async) !== ScreenSizeBreakpointNames.DESKTOP && shouldDisplayMobileHeaderAndMenu
    ) {
      <div @slideFromBottom class="sticky w-100 z-index-3 mobile-navigation-menu">
        <cp-mobile-navigation-menu class="v-h-centered" />
      </div>
    }
  </div>
</div>

@if (user && !user?.tutorialCleared && !authService.isImpersonated) {
  <cp-welcome-modal
    [welcomeModalData]="welcomeModalData$ | async"
    (skipButtonClick)="cancelTutorials()" />
}
